const map = {
	"./de-DE.json": [
		61034,
		[
			34
		]
	],
	"./es-ES.json": [
		980,
		[
			980
		]
	],
	"./fr-FR.json": [
		14192,
		[
			192
		]
	],
	"./it-IT.json": [
		59562,
		[
			562
		]
	],
	"./pt-BR.json": [
		50188,
		[
			188
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 51568;
module.exports = webpackAsyncContext;